<div class="container" #container [style.cursor]="disabled ? 'not-allowed' : 'pointer'">
    <div
        class="input-wrapper"
        (click)="openSelect()"
        [class.error]="inputValueCheck === ERROR"
        [ngClass]="{
            secondary: semantic === SECONDARY && isShowSelect,
            tertiary: semantic === TERTIARY && isShowSelect,
            'selecting-error': inputValueCheck === ERROR && isShowSelect,
        }">
        <div class="input-content">
            <input
                data-cy="ops-settings-system-setting-dropdown-field"
                [name]="name"
                [value]="emptyItem ? (emptyItem === inputValue ? '' : inputValue) : inputValue"
                [placeholder]="label | translate"
                readonly />

            <div class="selected-value" *ngIf="inputValue">{{ selectedValues }}</div>
        </div>
        <div class="arrow-wrapper">
            <mat-icon
                class="arrow"
                [class.dropdown-below]="isDropdownBelow"
                svgIcon="dropdown-arrow"
                [class.rotateBelow]="isDropdownBelow && isShowSelect && itemList" />
        </div>
    </div>

    <div
        *ngIf="isShowSelect && itemList"
        class="select-list-container"
        [class.dropdown-below]="isDropdownBelow"
        [ngStyle]="{
            width: dropdownWidth,
            top: optionsTop,
            left: optionsLeft,
            marginLeft: isDropdownBelow ? '0px' : '4px',
        }">
        <div *ngFor="let item of itemList" class="select-list" data-cy="ops-settings-system-setting-dropdown-option">
            <div class="item" [class.selected]="item === inputValue" (click)="selectValue($event, item, id)">
                <div class="item-action">
                    <span>{{ item }}</span>
                    <button class="edit-btn" *ngIf="displayEditButton(item)">Edit</button>
                </div>
                <mat-icon class="check" svgIcon="check" *ngIf="item === inputValue"></mat-icon>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #confirmationDialog
    [mainLabel]="mainMessage"
    [subLabel]="subMessage"
    [goBackLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"></app-confirmation-window>
